// Shared contracts for the v2 EHR appointment dialog. One visit per appointment.

import type { ManageAppointmentProps } from '../types'

// V2 needs to know whether the scheduled doctor books through OpenEMR; v1 and Charts do not.
export type ManageEhrAppointmentV2Props = ManageAppointmentProps & {
  hasEhrBooking: boolean
  // The doctor rail's staff in rail order; a person's avatar takes their rail color.
  railStaff?: { id: number }[]
}

// A bookable slot, minutes from midnight, on one day.
export type SlotOption = {
  day: string
  start: number
  end: number
}

export type DayResults = {
  day: string
  label: string
  options: SlotOption[]
  total: number
}

export const WINDOW_OPTIONS = [1, 7, 14, 30] as const
export const DEFAULT_WINDOW_DAYS = 1

export type SearchCriteria = {
  providerId: number | null
  windowStart: string
  windowDays: (typeof WINDOW_OPTIONS)[number]
}

// Which availability endpoint a doctor's dialog searches: OpenEMR's or the site's own.
export type AvailabilitySource = 'emr' | 'site'

// Minutes from midnight, site wall clock.
export type MinuteRange = {
  start: number
  end: number
}

// A booking read from /schedule/day, reduced to what the room filter needs.
export type RoomBooking = MinuteRange & {
  id: number
  roomCode: string
  statusCode: number | null
  patientFirstName: string | null
  patientLastName: string | null
  appointmentWith: string | null
}

// One day of the schedule: the rooms the doctor holds and every booking in them.
export type RoomDay = {
  date: string
  rooms: { code: string; hours: MinuteRange[] }[]
  bookings: RoomBooking[]
}
